import { apiClient } from '../../services/apiClient';

export type GenerationServiceType = 'image' | 'video';

export interface GenerationModel {
  id: string;
  service_type: GenerationServiceType;
  model_code: string;
  display_label: string;
  /** モデルファミリーの呼称 (例: 'GPT Image 2' / 'Gemini 3.1 Flash Image')。display_label (ティア名) と組み合わせて表示する */
  model_family_name: string | null;
  description: string | null;
  sort_order: number;
  is_default: boolean;
  is_recommended: boolean;
  is_active: boolean;
  supported_resolutions: string[] | null;
  supports_audio: boolean | null;
  supported_output_formats: string[] | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
  // 2026-05-10 追加: プロバイダ駆動 + 段階的ロールアウト用
  provider: string | null;
  supported_modes: string[] | null;
  supported_durations: number[] | null;
  supported_aspect_ratios: string[] | null;
  provider_endpoint: string | null;
  feature_flags: Record<string, unknown> | null;
}

interface ListResponse<T> {
  items: T[];
}

export async function fetchGenerationModels(serviceType?: GenerationServiceType): Promise<GenerationModel[]> {
  const params = serviceType ? `?service_type=${serviceType}` : '';
  const { data } = await apiClient.get<ListResponse<GenerationModel>>(`/generation/engine-models${params}`);
  return data.items ?? [];
}
